<template>
  <div v-if="loaded">
    <el-dialog
      :visible.sync="selfShow"
      width="80%"
      :title="popupTitle"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main" :style="{ height: maxHeight }">
        <ViewLeft
          v-if="isShowLeft"
          @toggle="popupToggle"
          :activeIndex.sync="selfIndex"
          :list="selfData.tableSaleData"
        />
        <div
          v-else
          class="popup-toggle iconfont icon-cebian-right"
          title="展开侧边栏"
          @click="popupToggle"
        ></div>
        <ViewRight :list="[selfData.tableSaleData[selfIndex]]" @print="jumpPrint" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    ViewLeft: () => import('./view-left'),
    ViewRight: () => import('./view-right')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    isVerify: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {},
      selfIndex: 0,
      isShowLeft: true
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 240}px`
      return result
    },
    popupTitle() {
      let result = ''
      let type = ''
      let code = ''
      let data = this.selfData.formData
      if (data) {
        if (this.isVerify) {
          type = data.status_str === '暂存' ? '核算单' : '订单'
        } else {
          type = '工程协同'
        }
        code = `(${data.bill_code})-`
      }
      result += type
      result += code
      result += '制造流程'
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      let url = '/admin/gcvip/checkBill2/detail'
      if (!this.isVerify) url = '/admin/gcvip/gongChengXieTong3/detail'
      await this.$api({
        method: 'get',
        url,
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    popupToggle() {
      this.isShowLeft = !this.isShowLeft
    },
    jumpPrint() {
      let url = '/new/verify/print/liucheng'
      if (!this.isVerify) url = '/new/gongcheng/print'
      let goodsId = this.selfData.tableSaleData[this.selfIndex].id
      window.open(`${url}?billId=${this.id}&goodsId=${goodsId}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  display: flex;
  .popup-toggle {
    height: 18px;
    padding: 5px;
    margin: 0 5px;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      color: @colorWhite;
      background: @colorBlue;
    }
  }
}
</style>
